function formatDate(date) {
  return date.toLocaleDateString("en-GB", { year: "numeric", month: "long", day: "numeric" });
}

function formatTime(date) {
  return date.toLocaleTimeString("en-GB", { hour: "2-digit", minute: "2-digit" });
}

function formatDateTimeString(date) {
  const dateTime = new Date(date);
  return dateTime.toLocaleString("en-GB", { year: "numeric", month: "long", day: "numeric", hour: "2-digit", minute: "2-digit" });
}

function formatDateString(date) {
  const dateTime = new Date(date);
  return dateTime.toLocaleDateString("en-GB", { year: "numeric", month: "numeric", day: "numeric" });
}

function getDateString(date) {
  if (!date) return null;
  return date.split("T")[0];
}

function getDateStringFromDate(date) {
  return date.toISOString().split("T")[0];
}

export { formatDate, formatTime, formatDateTimeString, getDateString, getDateStringFromDate, formatDateString };
